module.exports = __webpack_public_path__ + "img/banner-Ar.7e1158a0.png";